'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var checkMarkPath = 'M24,0 C37.2280889,0 48,10.7719111 48,24 C48,37.2280889 37.2280889,48 24,48 C10.7719111,48 0,37.2280889 0,24 C0,10.7719111 10.7719111,0 24,0 Z M24,3 C12.4184,3 3,12.4184 3,24 C3,35.5816 12.4184,45 24,45 C35.5816,45 45,35.5816 45,24 C45,12.4184 35.5816,3 24,3 Z M35.6999999,14.4 L37.8,16.5 L19.8,34.4999999 L11.4,26.1000001 L13.5,24 L19.8,30.3 L35.6999999,14.4 Z8z';

exports.default = checkMarkPath;
